// extracted by mini-css-extract-plugin
module.exports = {"chipWrapper":"styles_chipWrapper__n5rML"};